export default __webpack_public_path__ + "static/media/jordan_p.5097b7c3.jpg";